import React from "react";
import Image from "../assets/webdesign.jpg";
import Image2 from "../assets/Rectangle 1833 (1).png";
import Image3 from "../assets/Rectangle 1833 (2).png";
import Image4 from "../assets/Rectangle 1833 (3).png";
import html from "../assets/services/html.webp";
import css from "../assets/services/css1.jpg";
import js from "../assets/services/js.png";
import react from "../assets/services/react.png";
import angular from "../assets/services/Angular_full_color_logo.webp";
import laravel from "../assets/services/Laravel-Logo.wine.webp";
import vue from "../assets/services/vue.png";
import node from "../assets/services/nodejs.png";
import mongo from "../assets/services/mongo.png";
import mysql from "../assets/services/mysql.png";
import python from "../assets/services/Python.png";
import php from "../assets/services/php.png";
import amazon from "../assets/amazon-web-service.png";
import azure from "../assets/azure.png";
import google from "../assets/google-cloud.png";
import flutter from "../assets/services/flutter.png";
import reactNative from "../assets/services/reactNative.png";
import kotlin from "../assets/services/kotlin.jpg";
import ios from "../assets/services/ios.jpg";
import figma from "../assets/services/figma.png";
import photoshop from "../assets/services/photoshop.png";
import { useNavigate } from "react-router";
import { GoArrowUpRight } from "react-icons/go";

const Services = () => {
  const navigate = useNavigate();

  return (
    <>
      <div
        id="services"
        className="bg-gradient-to-b from-black to-blue-900 h-full px-6 sm:px-10 overflow-hidden pt-10"
      >
        <div className="flex justify-center items-center flex-col pt-10 text-center">
          <h1
            className="text-white text-4xl sm:text-5xl md:text-6xl"
            data-aos="fade-left"
            data-aos-duration="2000"
          >
            <span className="font-dancing pr-4">Our</span>Services
          </h1>
          <h2 className="text-white w-80 sm:w-auto mt-6 text-lg sm:text-2xl">
            Don’t let your competitors steal your shine. Get a website that
            stands out in today’s crowded online space.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-10 pb-10 md:px-20 mt-10">
          {[
            {
              title: "Website Design",
              description:
                "Creating visually appealing, user-friendly, functional online interfaces with seamless navigation, interactive elements.",
              image: Image,
              animation: "fade-right",
              button: "Read More",
              path: "/webdevelopment",
            },
            {
              title: "iOS/Android App",
              description:
                "Building intuitive and responsive mobile applications tailored to Apple's iOS and Google's a Android ecosystems.",
              image: Image2,
              animation: "fade-up",
              button: "Read More",
              path: "/android",
            },
            {
              title: "UI/UX Design",
              description:
                "Crafting intuitive interfaces and seamless user experiences that are visually appealing and easy to navigate.",
              image: Image3,
              animation: "fade-up",
              button: "Read More",
              path: "/uxui",
            },
            {
              title: "Digital Marketing",
              description:
                "Using online strategies to promote brands, products, or services through social media, search engines, websites, advertising.",
              image: Image4,
              animation: "fade-left",
              button: "Read More",
              path: "/marketing",
            },
          ].map((service, index) => (
            <div
              key={index}
              className="shadow-2xl px-6 border-b-2 border-white rounded-xl w-full max-w-sm sm:max-w-md md:max-w-lg h-auto hover:bg-blue-900 mx-auto"
              data-aos={service.animation}
              data-aos-duration="2500"
            >
              <h1 className="text-white font-bold text-xl sm:text-2xl mt-5 text-start">
                {service.title}
              </h1>
              <p className="text-white mt-5 text-sm sm:text-base text-start">
                {service.description}
              </p>

              {/* Centered Button */}
              <div className="flex justify-center">
                <button
                  className="mt-6 flex items-center gap-7 px-5 rounded-sm py-2 border border-transparent bg-orange-500 text-white font-semibold hover:bg-orange-600 hover:border-white transition duration-300 transform hover:scale-105 active:scale-95"
                  onClick={() => navigate(service.path)}
                >
                  <span className="text-lg transition-transform duration-300 hover:translate-x-1">
                    <GoArrowUpRight />
                  </span>
                  {service.button}
                </button>
              </div>

              <div className="mt-5 w-full flex justify-center">
                <img
                  className="w-full h-auto max-h-56 object-cover rounded-lg"
                  src={service.image}
                  alt={service.title}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className=" bg-[#FAEBCC] p-4">
        <div className="mt-9 mb-11 md:mt-16">
          <h3
            className="text-center text-3xl text-red-800 font-bold mb-6"
            data-aos="fade-right"
            data-aos-duration="2000"
          >
            <span className="font-dancing pr-4 text-4xl ">Technologies</span>
            We Are Expertise
          </h3>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto mb-14" />
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 px-24 mt-10 items-center justify-center">
            {[
              { src: html, name: "HTML" },
              { src: css, name: "CSS" },
              { src: js, name: "JavaScript" },
              { src: react, name: "React" },
              { src: angular, name: "Angular" },
              { src: laravel, name: "Laravel" },
              { src: vue, name: "Vue.js" },
              { src: node, name: "Node.js" },
              { src: python, name: "Python" },
              { src: mongo, name: "MongoDB" },
              { src: php, name: "PHP" },
              { src: mysql, name: "MySQL" },
              { src: ios, name: "iOS Development" },
              { src: kotlin, name: "Kotlin" },
              { src: reactNative, name: "React Native" },
              { src: flutter, name: "Flutter" },
              { src: photoshop, name: "Adobe Photoshop" },
              { src: figma, name: "Figma" },
            ].map((tech, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src={tech.src}
                  alt={tech.name}
                  className="shadow-md w-24  h-24 hover:shadow-lg transition duration-300 rounded-lg bg-transparent"
                />
                <p className="mt-1 text-xs font-medium text-gray-700 mb-3">
                  {tech.name}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-9 mb-11 md:mt-16">
          <h1
            className="text-center text-4xl text-red-800 font-bold"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <span className="font-dancing pr-4">Cloud</span>Technologies
          </h1>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto" />
          <div className="flex flex-wrap gap-4 mt-10 justify-center">
            <img src={google} alt="google" className="sm:w-32 md:w-48" />
            <img src={azure} alt="Azure" className="sm:w-32 md:w-48" />
            <img src={amazon} alt="amazon" className="sm:w-24 md:w-48" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
